var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hourglass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 11.1v-9h4v-2h-32v2h4v8.9c0 3.5 1.7 6.8 4.5 8.9l5.8 4.2-5.8 4.2c-2.8 2.1-4.5 5.4-4.5 8.9v8.9h-4v2h32v-2h-4v-8.9c0-3.5-1.7-6.8-4.5-8.9l-5.8-4.2 5.8-4.2c2.8-2 4.5-5.3 4.5-8.8zm-22 35v-5.1l10-1.8 10 1.8v5.2h-20v-0.1zm16.3-16.1c2.3 1.7 3.7 4.4 3.7 7.3v1.7l-10-1.8-10 1.7v-1.7c0-2.9 1.4-5.6 3.7-7.3l6.3-4.6 6.3 4.7zm0-11.7l-6.3 4.6-6.3-4.6c-2.3-1.7-3.7-4.4-3.7-7.2v-9h20v8.9c0 2.9-1.4 5.6-3.7 7.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.677fbed4dc6b3cd798e3bdc92b23fcc9.svg";
export { ForwardRef as ReactComponent };